/**
 * @file IconMore Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-more',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.5}"
  >
    <rect width="48" height="48" x="0" y="0" />
    <g transform="translate(6,6)">
      <path
        fill="${data.colorDesc[0]}"
        fill-rule="nonzero"
        d="M18 0C27.94113 0 36 8.05887 36 18 36 27.94113 27.94113 36 18 36 8.05887 36 0 27.94113 0 18 0 8.05887 8.05887 0 18 0ZM18 2C9.16344 2 2 9.16344 2 18 2 26.83656 9.16344 34 18 34 26.83656 34 34 26.83656 34 18 34 9.16344 26.83656 2 18 2ZM12 16C13.10457 16 14 16.89543 14 18 14 19.02567 13.22792 19.87101 12.23324 19.98654L12 20C10.89543 20 10 19.10457 10 18 10 16.97433 10.77208 16.12899 11.76676 16.01346L12 16ZM18 16C19.10457 16 20 16.89543 20 18 20 19.02567 19.22792 19.87101 18.23324 19.98654L18 20C16.89543 20 16 19.10457 16 18 16 16.97433 16.77208 16.12899 17.76676 16.01346L18 16ZM24 16C25.10457 16 26 16.89543 26 18 26 19.02567 25.22792 19.87101 24.23324 19.98654L24 20C22.89543 20 22 19.10457 22 18 22 16.97433 22.77208 16.12899 23.76676 16.01346L24 16Z"
      />
      <g transform="translate(10,16)" />
    </g>
  </g>
</svg>
`
);
